export default class BrowserConstants {
  static THRESHOLDS = [...[...Array(100).keys()].map(i => i / 100), 1];
  constructor() {
    throw Error("This class cannot be instantiated");
  }
}
